export default "/images/telega.png?2c9a000fe8647389ff1f7491a11018e7";